import productionConfiguration from '../config/default.json';
import readConfig from './readClientConfiguration';

export const resolveLinkProps = link => {
  let isExternalUrl;
  const linkProps = {};

  try {
    if (link===undefined){
      link='#'
    }
    link=link.trim()
    link=link.replace('https://admin.emmezeta.hr/','/')
    link=link.replace('https://admin.emmezeta.local/','/')
    const base_url = readConfig(productionConfiguration, 'base_url');
    const urlObj = new URL(link);
    const baseUrlObj = new URL(base_url);


    // Normalize hosts by removing www prefix for comparison
    const normalizeHost = (host) => host.replace(/^www\./, '');
    const isInternalHost = normalizeHost(urlObj.host) === normalizeHost(baseUrlObj.host);
    isExternalUrl = !isInternalHost;
    if (isExternalUrl) {
      linkProps['href'] = link;
    } else {
      linkProps['to'] = urlObj.pathname;
    }
  } catch (e) {
    linkProps['to'] = link;
  }

  return linkProps;
};
